/**
 * The form keeps a day the way the design writes it, `dd/mm/yyyy`; the API takes ISO `yyyy-mm-dd`.
 * Undefined unless the text is a whole date that exists: `31/02/2027` is not a day.
 */
export const isoFromUk = (text: string) => {
  const [day, month, year] = text.split('/')
  if (day?.length !== 2 || month?.length !== 2 || year?.length !== 4) return undefined
  const iso = `${year}-${month}-${day}`
  // A day that does not exist rolls over into the next month or fails to parse; neither reads back as itself.
  return new Date(`${iso}T00:00`).toLocaleDateString('en-CA') === iso ? iso : undefined
}

export const ukFromIso = (iso: string) => iso.split('-').toReversed().join('/')
